import React from 'react';
import IndexDetail from './IndexDetail';

const IndexList = ({ indexes }) => {
  if (indexes && indexes.length > 0) {
    return indexes.map(index => <IndexDetail index={index} key={index.uuid} />);
  }
  return '';
};

export default IndexList;
